"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Wrapper = exports.baseStyles = exports.CONFIG = exports.SIZES = void 0;
var styled_components_1 = __importStar(require("styled-components"));
var media_1 = require("../../../theme/media");
var theme_1 = require("../../../theme");
exports.SIZES = {
    1: {
        fontSize: '60px',
        lineHeight: '68px',
    },
    2: {
        fontSize: '48px',
        lineHeight: '54px',
    },
    3: {
        fontSize: '36px',
        lineHeight: '45px',
    },
    4: {
        fontSize: '24px',
        lineHeight: '29px',
    },
    5: {
        fontSize: '20px',
        lineHeight: '25px',
    },
    6: {
        fontSize: '16px',
        lineHeight: '20px',
    },
};
exports.CONFIG = {
    1: {
        large: exports.SIZES[1],
        medium: exports.SIZES[2],
        small: exports.SIZES[3],
    },
    2: {
        large: exports.SIZES[2],
        medium: exports.SIZES[3],
        small: exports.SIZES[4],
    },
    3: {
        large: exports.SIZES[3],
        medium: exports.SIZES[4],
        small: exports.SIZES[5],
    },
    4: {
        large: exports.SIZES[4],
        medium: exports.SIZES[5],
        small: exports.SIZES[5],
    },
    5: {
        large: exports.SIZES[5],
        medium: exports.SIZES[6],
        small: exports.SIZES[6],
    },
    6: {
        large: exports.SIZES[6],
        medium: exports.SIZES[6],
        small: exports.SIZES[6],
    },
};
exports.baseStyles = styled_components_1.css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  font-family: ", "\n      'Px',\n    Helvetica, Arial, sans-serif;\n  font-weight: normal;\n  letter-spacing: ", ";\n\n  ", "\n"], ["\n  font-family: ",
    "\n      'Px',\n    Helvetica, Arial, sans-serif;\n  font-weight: normal;\n  letter-spacing: ",
    ";\n\n  ",
    "\n"])), function (_a) {
    var theme = _a.theme;
    return (theme === null || theme === void 0 ? void 0 : theme.headingFontOverride) ? "'" + theme.headingFontOverride + "', " : '';
}, function (_a) {
    var theme = _a.theme;
    return (theme === null || theme === void 0 ? void 0 : theme.headingFontOverride) ? '' : '-0.0165em';
}, function (_a) {
    var _b = _a.$level, $level = _b === void 0 ? '1' : _b;
    return styled_components_1.css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    font-size: ", ";\n    line-height: ", ";\n\n    @media ", " {\n      font-size: ", ";\n      line-height: ", ";\n    }\n\n    @media ", " {\n      font-size: ", ";\n      line-height: ", ";\n    }\n  "], ["\n    font-size: ", ";\n    line-height: ", ";\n\n    @media ", " {\n      font-size: ", ";\n      line-height: ", ";\n    }\n\n    @media ", " {\n      font-size: ", ";\n      line-height: ", ";\n    }\n  "])), exports.CONFIG[$level].small.fontSize, exports.CONFIG[$level].small.lineHeight, media_1.breakpoints.medium, exports.CONFIG[$level].medium.fontSize, exports.CONFIG[$level].medium.lineHeight, media_1.breakpoints.large, exports.CONFIG[$level].large.fontSize, exports.CONFIG[$level].large.lineHeight);
});
exports.Wrapper = styled_components_1.default.h1.attrs(function (_a) {
    var _b = _a.$level, $level = _b === void 0 ? '1' : _b, as = _a.as, $asLevel = _a.$asLevel;
    return ({
        as: $asLevel ? "h" + $asLevel : as || "h" + $level,
    });
})(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  ", "\n  color: ", ";\n  margin: 0;\n  max-width: ", ";\n"], ["\n  ", "\n  color: ", ";\n  margin: 0;\n  max-width: ", ";\n"])), exports.baseStyles, function (_a) {
    var $color = _a.$color;
    return ($color ? theme_1.theme.colors[$color] : 'currentColor');
}, function (_a) {
    var $maxWidth = _a.$maxWidth;
    return ($maxWidth ? $maxWidth + "em" : '');
});
var templateObject_1, templateObject_2, templateObject_3;
